/**
 * A list of valid email subject strings.
 * NOTE: The index in this object is not to
 * be used as the select input value. The values
 * in this object is both the select input value
 * and the display text.
 */
export const emailSubjects = {
    "complaints"  : "Complaints",
    "shareholder" : "Shareholder Enquiry",
    "pressMedia"  : "Press/ Media Enquiry",
    "other"       : "Other Enquiry",
};

/**
 * Mapping email address recipients by contact us
 * email subject.
 */
export const emailAddressMapping = {
    [emailSubjects.complaints]: [
        "complaints@money3.com.au",
    ],
    [emailSubjects.shareholder]: [
        "s.baldwin@solvar.com.au",
        "s.subramani@solvar.com.au"
    ],
    [emailSubjects.pressMedia]: [
        "s.baldwin@solvar.com.au",
        "s.subramani@solvar.com.au"
    ],
    [emailSubjects.other]: [
        "customercare@money3.com.au"
    ]
};

/**
 * Determines the To email addresses for the contact us
 * email based on the given `subject` string.
 *
 * @param {string} subject - The subject string to be checked.
 * @returns {Array<string>} - Returns an array of email strings.
 */
export function determineToEmailAddresses(subject)
{
    return (emailAddressMapping[subject] ?? []);
}